module.exports = {"TXTWCL_Close":{"id":"TXTWCL_Close","defaultMessage":"Luk","track":"Close"}}